module.exports = "<div class=\"error-wrapper\">\n  <span *ngFor=\"let error of errors\">\n    {{error}}\n  </span>\n</div>\n"